angular.module('CarsSaraBo').controller('CompanyController',
    ['$scope', '$routeParams', '$q', 'CompanyService', 'ResourceService', '$http', '$translate', 'Upload', '$location', '$cookieStore', '$rootScope', 'CacheService',
        'NotificationService','$timeout','CompanyServiceA2', 'GeoService', 'EmailValidatorService',
        function ($scope, $routeParams, $q, companyService, resourceService, $http, $translate, Upload, $location, $cookieStore, $rootScope, cacheService,
                  notificationService, $timeout, CompanyServiceA2, geoService, emailValidatorService) {

            $scope.countryCodes={
                'COLOMBIA'      :'20045',
                'CHILE'         :'20042',
                'ECUADOR'       :'20057',
                'PANAMA'        :'20157',
                'ARGENTINA'     :'20010',
                'MEXICO'        :'20141',
                'PERU'          :'20158',
                'BRAZIL'        :'20028',
                'BOLIVIA'       :'20027',
                'EL_SALVADOR'   :'20188',
                'GUATEMALA'     :'20081',
                'URUGUAY'       :'20209',
                'COSTA_RICA'    :'20046',
                'NICARAGUA'     :'20149',
                'PARAGUAY'      :'20168',
                'ESPANA'        :'20061',
                'ESTADOS_UNIDOS':'20208',
                'PUERTO_RICO'   :'20165',
                'HONDURAS'      :'20086',
                'VENEZUELA'     :'20213',
                'ISLAS_SALOMON' :'20175',
                'REPUBLICA_DOMINICANA':'20055',
                'SANTO_TOME_Y_PRINCIPE':'20187'
            }

            $scope.zipCodeLength={
                '20045'      : 6,
                '20141'      : 5,
            }

            $scope.documentTypes = {
                '20045':['CC', 'NIT'],
                '20042':['RUT','RUN'],
                '20057':['CI','RUC']
            }
            $scope.panamaPersonType=[
                {value:"NATURAL"},
                {value:"LEGAL"}
            ]

            $scope.getCountryOid = function(countryName){
                return this.countryCodes[countryName];
            }

            $scope.getZipCodeLength = function(countryOid){
                return this.zipCodeLength[countryOid];
            }

            $scope.isCountry = function(countryName){
                return $scope.company.countryOid === this.getCountryOid(countryName);
            }

            $scope.zipCodeValidationIsRequired = function() {
                return this.isCountry('COLOMBIA') || this.isCountry('MEXICO');
            }


            $scope.zipCodeLengthIsValid = function() {
                return $scope.company.zipCode != null && ($scope.company.zipCode.length === this.getZipCodeLength($scope.company.countryOid));
            }

            $scope.initialize = function () {
                $scope.cuil = null;
                $scope.companyOid = $routeParams.oid;
                $scope.panama= {
                    ruc: null,
                    rucDV:null,
                    PN:true,
                    PJ:false
                }
                $scope.loadCompany();
                $rootScope.showSubMenu = true;
                $scope.company = {administrativeContact: {}, commercialContact: {}, emergencyContact: {}, operatingContact: {}, logo: {}};
                $scope.companyLogo = null;
                $scope.obj = {};
                $scope.mapVatNumberLabel();
                $scope.regexEmail = "/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/";
                $scope.regexPanamaRuc= /^([A-Z0-9]+-{0,1})*$/;
                $scope.regexPanamaRucDV=/^[0-9]{1,2}$/;
                $scope.regexColombiaRNT=/^[0-9]*$/;
                $scope.regexBrazilCnpj=/^[A-Z0-9]{12}[0-9]{2}$/;
                $scope.showValidationMessage = true;
                $scope.originalBrazilVatNumber = null;
            }

            $scope.upload = function () {

            $scope.updateValidation('companyLogo');
            if ($scope.obj.flow.files[0] && $scope.obj.flow.files.length > 0) {
                var fileUploaded = $scope.obj.flow.files[0].file;
                Upload.upload({
                    url: '../rest/company/uploadLogo',
                    file: fileUploaded
                }).progress(function (evt) {

                    }).success(function (data, status, headers, config) {
                        notificationService.notifyInfoByCode('uploadLogo.SUCCESS');
                        $scope.company.logo = {};
                        $scope.company.logo.fileName = data.token;
                        $scope.company.logo.title = data.title;
                        $scope.company.logo.oid = null;
                        $scope.company.logoOid = null;
                        $scope.getLogo();
                    }).error(function (data, status, headers, config) {
                        notificationService.notifyFrontErrorDetailByCodes(data);
                    });
                } else {
                    notificationService.notifyErrorByCode('ERROR.company.logo.format');
                    return false;
                }
            }

            $scope.handlePersonTypeChange= function(personType){
                $scope.panamaPersonType.forEach((type)=>{ segment.checked = segment.value === segmentChecked;});
            };

            $scope.loadCompany = function () {
                $scope.natures = ['Persona juridica', 'Persona natural']
                geoService.getCountries().then(function (countries) {
                    $scope.countries = countries;
                });

                $http.get("../rest/data/province").then(function (provinces) {
                    $scope.statesInBrazil = provinces;
                });

                if ($scope.companyOid == 'new') {
                    $scope.basicAdministrativeDataEdit = $scope.loggedUserAllowed('PERM_ADMIN_DATA_CREATE');
                    $scope.fullAdministrativeDataEdit = $scope.loggedUserAllowed('PERM_ADMIN_DATA_CREATE');
                    $scope.showAdministrativeData();
                    return;
                } else {
                    $scope.basicAdministrativeDataEdit = $scope.loggedUserAllowed('PERM_ADMIN_DATA_EDIT');
                    $scope.fullAdministrativeDataEdit = $scope.loggedUserAllowed("PERM_ADMIN_DATA_FULL_EDIT");
                }

                CompanyServiceA2.get($scope.companyOid).subscribe(function(data){
                    $scope.company = data;
                    $scope.company.countryOid = $scope.company.countryOid.toString();
                    $scope.getLogo();
                    $scope.listaEjemplo = [];
                    $scope.updateTaxes();
                    $scope.updateReceiptMethods();
                    $scope.showAdministrativeData();
                    $scope.fillPhoneNumber($scope.company);
                    $scope.updatePersonTypes();
                    $scope.updateEconomicalActivities();
                    $timeout(function () {
                        $scope.showValidationMessage = false;
                    }, 5000);
                    var vatNumber = $scope.company.vatNumber;
                    $scope.originalBrazilVatNumber = vatNumber;
                    $scope.setVatNumberforView(vatNumber);
                });

            }

            $scope.cityLike = function (like) {
                $scope.company.cityOid = null;
                return geoService.getCities(like, $rootScope.lang.name).then(function (response) {
                    return response.data
                });
            }

            $scope.setFiscalInfo = function(){
                if (!!$scope.company.fiscalInfo){
                    $scope.panama.PN = $scope.company.fiscalInfo.documentType === 'NATURAL';
                    $scope.panama.PJ = !$scope.panama.PN;
                }else{
                    $scope.company.fiscalInfo = {type:'NATURAL'};
                }
            }

            $scope.onSelectCity = function (city) {
                $scope.company.city = city.description;
                $scope.company.cityOid = city.locationOid;
            }

            $scope.fillPhoneNumber = function (company) {
                $scope.splitPhoneNumber(company.administrativeContact);
                $scope.splitPhoneNumber(company.commercialContact);
                $scope.splitPhoneNumber(company.operatingContact);
                $scope.splitPhoneNumber(company.emergencyContact);
            }

            $scope.setVatNumberforView = function (vatNumber) {
                switch ($scope.company.countryOid) {
                    case this.getCountryOid('PANAMA'):
                        var splitVatNumber = $scope.replaceAtIndex(vatNumber,vatNumber.lastIndexOf("DV"),"DV","#").split("#");
                        $scope.panama.ruc = splitVatNumber[0];
                        $scope.panama.rucDV = splitVatNumber[1];
                        $scope.setFiscalInfo();
                        break;
                    case this.getCountryOid('BRAZIL'):
                        this.cuil = $scope.formatBrazilCnpj(vatNumber);
                        break;
                    default : this.cuil = $scope.company.vatNumber;
                }

            }

            $scope.splitPhoneNumber = function (contact) {
                if (contact && contact.phone) {
                    var index = contact.phone.indexOf("-");
                    contact.phoneArea = contact.phone.substring(0, index);
                    contact.phoneNumber = contact.phone.substring(index + 1, contact.phone.length);
                }
            }

            $scope.cancel = function () {
                $scope.showModal("CANCEL_ALERT_TITLE", "CANCEL_ALERT_DESCRIPTION", function () {
                    var oid = $routeParams.oid == undefined ? "new" : $routeParams.oid;
                    $location.path("/company/" + oid);
                });
            }


            $scope.onNatureChange = function(){
                if(!$scope.company.fiscalInfo){
                    return;
                }
                $scope.company.fiscalInfo.name = null;
                $scope.company.fiscalInfo.lastName = null;
                $scope.company.companyName = null;
                $scope.updateEconomicalActivities();
            }

            $scope.onCountryChange = function () {
                if ($scope.company.countryOid != null && $scope.company.countryOid != undefined) {
                    $scope.updateTaxes();
                    $scope.updateReceiptMethods();
                    $scope.company.fiscalInfo = null;
                    $scope.company.countryCode = null;
                    $scope.getVatNumberLabel($scope.company.countryOid);
                    $scope.updatePersonTypes();

                } else {
                    $scope.taxConditions = [];
                    $scope.receiptMethods = [];
                }
                $scope.company.vatNumber = "";
                $scope.originalBrazilVatNumber = null;
                $scope.updateEconomicalActivities();
            }


            validateZipCode = function () {
                $scope.errorField = [];
                if($scope.zipCodeValidationIsRequired() && $scope.zipCodeLengthIsValid() && $scope.fullAdministrativeDataEdit){
                    isZipCodeValid(function(){
                        var zipcode = $scope.company.zipCode;
                        $scope.errorField['zipcode'] = "input-error";
                        var errorList = [];
                        errorList.push({
                            code: "company.ZIPCODE_NOT_EXIST",
                            params: {
                                zipcodeData: zipcode
                            }
                        });
                        notificationService.notifyErrorByCodeWithParams(errorList[0].code, errorList[0].params);
                    }, function(){
                        $scope.save();
                    });
                }else{
                    $scope.save();
                }
            }

            $scope.updateTaxes = function () {
                $http.get("../rest/data/taxConditions/" + $scope.company.countryOid).then(function (conditions) {
                    $scope.taxConditions = conditions.data.map(function (fiscoCode) {
                        return {
                            code: fiscoCode,
                        };
                    });
                });
            }

            $scope.updatePersonTypes = function () {
                if ($scope.shouldShow('PERSON_TYPES')) {
                    $http.get("../rest/company/person-type?countryOid=" +  $scope.company.countryOid).then(function (personTypes) {
                        $scope.personTypes = personTypes.data;
                    });
                }
            }

            isZipCodeValid = function (callbackError, callbackSuccess) {
                var targetUrl = "../rest/cfa/country/{country}/zipcode?code={zipcode}";
                targetUrl = targetUrl.replace("{country}", $scope.company.countryOid).replace("{zipcode}", $scope.company.zipCode);
                $http.get(targetUrl).then(function (response) {
                    if(!(response && response.data && response.data.code)){
                        callbackError();
                    }else{
                        callbackSuccess();
                    }
                });
            }

            $scope.updateEconomicalActivities = function(){

                if ($scope.shouldShow('ECONOMICAL_ACTIVITIES') && !!$scope.company.fiscalInfo &&  !!$scope.company.fiscalInfo.type) {
                    $http.get("../rest/cfa/country/" + $scope.company.countryOid + "/economicActivities/" + $scope.company.fiscalInfo.type).then(function (economicalActivities) {
                        $scope.economicalActivities = economicalActivities.data;
                    });
                }
            }

            $scope.updateReceiptMethods = function () {
                $http.get("../rest/data/receiptMethod/" + $scope.company.countryOid).then(function (methods) {
                    $scope.receiptMethods = methods.data.map(function (methodCode) {
                        return {
                            code: methodCode,
                        };
                    });
                });
            }

            $scope.translate = function (code) {
                return $translate.instant(code);
            }

            $scope.cleanContact = function () {
                var hasAtrr = false;
                for (i in $scope.company.emergencyContact) {
                    if ($scope.company.emergencyContact[i] != null && $scope.company.emergencyContact[i] != undefined) {
                        hasAtrr = true;
                    }
                }
                if (!hasAtrr) {
                    $scope.company.emergencyContact = null;
                }
                hasAtrr = false;
                for (i in $scope.company.operatingContact) {
                    if ($scope.company.operatingContact[i] != null && $scope.company.operatingContact[i] != undefined) {
                        hasAtrr = true;
                    }
                }
                if (!hasAtrr) {
                    $scope.company.operatingContact = null;
                }
            }

            $scope.$watch('company', function (company, oldValue) {
                $scope.editableAddress = company.oid == null
                    || company.oid == undefined
                    || company.city == ""
                    || company.city == undefined
                    || company.city == null
            });

            $scope.$watch('company.administrativeContact.phoneArea', function (newValue, oldValue) {
                $scope.updateContactPhone($scope.company.administrativeContact);
            });
            $scope.$watch('company.administrativeContact.phoneNumber', function (newValue, oldValue) {
                $scope.updateContactPhone($scope.company.administrativeContact);
            });
            $scope.$watch('company.commercialContact.phoneArea', function (newValue, oldValue) {
                $scope.updateContactPhone($scope.company.commercialContact);
            });
            $scope.$watch('company.commercialContact.phoneNumber', function (newValue, oldValue) {
                $scope.updateContactPhone($scope.company.commercialContact);
            });
            $scope.$watch('company.operatingContact.phoneArea', function (newValue, oldValue) {
                $scope.updateContactPhone($scope.company.operatingContact);
            });
            $scope.$watch('company.operatingContact.phoneNumber', function (newValue, oldValue) {
                $scope.updateContactPhone($scope.company.operatingContact);
            });
            $scope.$watch('company.emergencyContact.phoneArea', function (newValue, oldValue) {
                $scope.updateContactPhone($scope.company.emergencyContact);
            });
            $scope.$watch('company.emergencyContact.phoneNumber', function (newValue, oldValue) {
                $scope.updateContactPhone($scope.company.emergencyContact);
            });

            $scope.updateContactPhone = function (contact) {
                contact.phone = "";
                if (contact.phoneArea != null && contact.phoneArea != undefined) {
                    contact.phone = contact.phoneArea;
                }
                if (contact.phoneNumber != null && contact.phoneNumber != undefined) {
                    if (contact.phone != "") {
                        contact.phone = contact.phone + "-"
                    }
                    contact.phone = contact.phone + contact.phoneNumber
                }
            };

            $scope.validate = function () {
                $http.post("../rest/company/" + $scope.company.oid + "/validate").then(function () {
                    $scope.initialize();
                });
            };

            $scope.setVatNumber = function(contryOid) {
                switch (contryOid) {
                    case  this.getCountryOid('PANAMA'): $scope.company.vatNumber = ($scope.panama.ruc + 'DV' + $scope.panama.rucDV).toUpperCase(); break;
                    case  this.getCountryOid('BRAZIL'): $scope.company.vatNumber = $scope.formatBrazilCnpj(this.cuil); break;
                    default : $scope.company.vatNumber = this.cuil;
                }
            }

            $scope.saveData = function(){
                validateZipCode();
            };

            $scope.save = function () {
                $scope.errorField = {};
                $scope.submitted = true;
                $scope.setVatNumber($scope.company.countryOid);
                $scope.cleanNotRequiredContacts();
                if ($scope.valid() && $scope.companyForm.$valid && $scope.administrativeContactForm.$valid && $scope.commercialContactForm.$valid) {
                    var shouldIgnoreGlobalHttpErrorHandling = $scope.isCountry('BRAZIL');
                    var previousIgnoreGlobalHttpErrorHandling = $rootScope.ignoreGlobalHttpErrorHandling;

                    if (shouldIgnoreGlobalHttpErrorHandling) {
                        $rootScope.setIgnoreGlobalHttpErrorHandling(true);
                    }

                    var restoreGlobalHttpErrorHandling = function () {
                        if (shouldIgnoreGlobalHttpErrorHandling) {
                            $rootScope.setIgnoreGlobalHttpErrorHandling(previousIgnoreGlobalHttpErrorHandling);
                        }
                    };

                    if ($scope.companyOid == "new") {
                        promise = companyService.save($scope.company).$promise;
                    } else {
                        promise = companyService.update({oid: $scope.companyOid}, $scope.company).$promise;
                    }
                    promise.then(function (response) {
                        restoreGlobalHttpErrorHandling();
                        notificationService.notifyInfoByCode('company.confirmationMessage.SUCCESS_SAVE');
                        $scope.goToNewCompany(response);
                        cacheService.clean("companies");
                    }, function (error) {
                        restoreGlobalHttpErrorHandling();
                        var backendErrors = $scope.normalizeBrazilVatErrors(!!error.data ? error.data : 'common.confirmationMessage.ERROR_SAVE');
                        notificationService.notifyFrontErrorDetailByCodes(backendErrors);
                    });
                } else {
                    for (i in $scope.companyForm.$error.required) {
                        $scope.errorField[$scope.companyForm.$error.required[i].$name] = "input-error";
                    }
                    $scope.errorField['0'] = ($scope.companyForm.$error.required != undefined && $scope.companyForm.$error.required.length > 0) ? true : false;

                    for (i in $scope.administrativeContactForm.$error.required) {
                        $scope.errorField[$scope.administrativeContactForm.$error.required[i].$name] = "input-error";
                    }
                    $scope.errorField['1'] = ($scope.administrativeContactForm.$error.required != undefined && $scope.administrativeContactForm.$error.required.length) > 0 ? true : false;

                    for (i in $scope.commercialContactForm.$error.required) {
                        $scope.errorField[$scope.commercialContactForm.$error.required[i].$name] = "input-error";
                    }
                    $scope.errorField['2'] = ($scope.commercialContactForm.$error.required != undefined && $scope.commercialContactForm.$error.required.length > 0) ? true : false;
                }
                $scope.notifyFormErrors($scope.companyForm.$error);
                $scope.notifyFormErrors($scope.administrativeContactForm.$error);
                $scope.notifyFormErrors($scope.commercialContactForm.$error);
            }

            $scope.goToNewCompany = function (company) {
                if ($scope.companyOid == "new") {
                    $scope.setCompanyToRepresent(company);
                    $rootScope.sidebarVisible = true;
                    $scope.goToDefaultTargetUrl(company.oid);
                } else {
                    $location.path("/company/" + $scope.companyOid);
                }
            }

            $scope.cleanNotRequiredContacts = function () {
                if ($scope.company.operatingContact && (!$scope.company.operatingContact.firstName || !$scope.company.operatingContact.lastName)) {
                    $scope.company.operatingContact = null;
                }

                if ($scope.company.emergencyContact && (!$scope.company.emergencyContact.firstName || !$scope.company.emergencyContact.lastName)) {
                    $scope.company.emergencyContact = null;
                }
            }

            $scope.updateValidation = function (field) {
                if ($scope.errorField != undefined && $scope.errorField[field]) {
                    $scope.errorField[field] = null;
                }
            }

            $scope.normalizeBrazilVatErrorCode = function(code) {
                if (!$scope.isCountry('BRAZIL')) {
                    return code;
                }

                if (code === "warning.invalidNumberFormat" || code === "cnpj.validation") {
                    return "company.INCORRECT_CNPJ";
                }

                return code;
            }

            $scope.normalizeBrazilVatErrors = function(errors) {
                if (!$scope.isCountry('BRAZIL') || !errors) {
                    return errors;
                }

                if (Array.isArray(errors)) {
                    return errors.map(function(errorItem) {
                        if (typeof errorItem === 'string') {
                            return $scope.normalizeBrazilVatErrorCode(errorItem);
                        }

                        if (errorItem && errorItem.code) {
                            var normalizedItem = angular.copy(errorItem);
                            normalizedItem.code = $scope.normalizeBrazilVatErrorCode(errorItem.code);
                            return normalizedItem;
                        }

                        return errorItem;
                    });
                }

                if (typeof errors === 'string') {
                    return $scope.normalizeBrazilVatErrorCode(errors);
                }

                if (errors.code) {
                    var normalized = angular.copy(errors);
                    normalized.code = $scope.normalizeBrazilVatErrorCode(errors.code);
                    return normalized;
                }

                return errors;
            }

            $scope.updateValidationVatNumber = function (field) {
                if ($scope.errorField != undefined && $scope.errorField[field]) {
                    $scope.errorField[field] = null;
                }

                if ($scope.isCountry('BRAZIL')) {
                    $scope.cuil = $scope.formatBrazilCnpj($scope.cuil);
                    return;
                }

                var cuitLenght = $scope.company.vatNumber.length;

                if ($scope.isCountry('ARGENTINA')) {
                    if ((cuitLenght == 2 && $scope.company.vatNumber.substring(1, 2) != '-') ||
                        (cuitLenght == 11 && $scope.company.vatNumber.substring(11, 12) != '-') &&
                        $scope.company.vatNumber.substring((cuitLenght - 1), cuitLenght) != '-' &&
                        $scope.company.vatNumber.split('-').length != 3) {
                        $scope.company.vatNumber += '-';
                    } else if (cuitLenght == 3 && $scope.company.vatNumber.substring(2, 3) != '-') {
                        var lastNumber = $scope.company.vatNumber.substring(2, 3);
                        $scope.company.vatNumber = $scope.company.vatNumber.substring(0, 2);
                        $scope.company.vatNumber += '-';
                        $scope.company.vatNumber += lastNumber;
                    } else if (cuitLenght == 3) {
                        $scope.company.vatNumber = $scope.company.vatNumber.substring(0, 2);
                    } else if (cuitLenght == 12 && $scope.company.vatNumber.substring(11, 12) != '-') {
                        var lastNumber = $scope.company.vatNumber.substring(11, 12);
                        $scope.company.vatNumber = $scope.company.vatNumber.substring(0, 11);
                        $scope.company.vatNumber += '-';
                        $scope.company.vatNumber += lastNumber;
                    } else if (cuitLenght == 12) {
                        $scope.company.vatNumber = $scope.company.vatNumber.substring(0, 11);
                    } else if (cuitLenght == 12 && $scope.company.vatNumber.substring(11, 12) == '-') {
                        $scope.company.vatNumber = $scope.company.vatNumber.substring(0, 11);
                    }
                }
            }

            $scope.valid = function () {
                var errorList = [];
                var isValid = true;

                if ($scope.company.cityOid == null) {
                    $scope.errorField['cityOid'] = "input-error";
                    errorList.push("ERROR.company.city.required");
                    isValid = false;
                }

                if ($scope.errorField == undefined)$scope.errorField = {};
                if (!$scope.company.administrativeContact.phoneNumber || !$scope.company.administrativeContact.phoneArea) {
                    $scope.errorField['administrativePhone'] = "input-error";
                    isValid = false;
                }

                if (($scope.company.administrativeContact.phoneNumber && !Number.isInteger(parseInt($scope.company.administrativeContact.phoneNumber)))
                    || (!Number.isInteger(parseInt($scope.company.administrativeContact.phoneArea)) && $scope.company.administrativeContact.phoneArea)) {
                    $scope.errorField['administrativePhone'] = "input-error";
                    errorList.push("company.PHONE_ONLY_NUMBER_ADM");
                    isValid = false;
                }

                if (!$scope.company.commercialContact.phoneNumber || !$scope.company.commercialContact.phoneArea) {
                    $scope.errorField['commercialPhone'] = "input-error";
                    isValid = false;
                }

                if (($scope.company.commercialContact.phoneNumber && !Number.isInteger(parseInt($scope.company.commercialContact.phoneNumber)))
                    || ( $scope.company.commercialContact.phoneArea && !Number.isInteger(parseInt($scope.company.commercialContact.phoneArea)))) {
                    $scope.errorField['commercialPhone'] = "input-error";
                    errorList.push("company.PHONE_ONLY_NUMBER_COM");
                    isValid = false;
                }

                if (($scope.company.logo && !$scope.company.logo.fileName) || (!$scope.company.logo && !$scope.company.logoOid)) {
                    $scope.errorField['companyLogo'] = "input-error";
                    isValid = false;
                }

                if ($scope.company.nationalTourismRegistry) {

                    if(!$scope.isValidRNTLength($scope.company.nationalTourismRegistry)){
                        $scope.errorField['nationalTourismRegistry'] = "input-error";
                        errorList.push($translate.instant('company.validation.max', {length:20}));
                        isValid = false;
                    }

                    if(!$scope.isValidRNT($scope.company.nationalTourismRegistry)){
                        $scope.errorField['nationalTourismRegistry'] = "input-error";
                        errorList.push("warning.invalidNumberFormat");
                        isValid = false;
                    }
                }

                if($scope.zipCodeValidationIsRequired()) {
                    if (!$scope.zipCodeLengthIsValid()) {

                        const zipCodeLength = this.getZipCodeLength($scope.company.countryOid);

                        $scope.errorField['zipcode'] = "input-error";
                        var errors = [];
                        errors.push({
                                code:  "company.ZIPCODE_MINLENGTH",
                                params: {
                                    zipcodeLength: zipCodeLength
                                }
                        });
                        notificationService.notifyErrorByCodeWithParams(errors[0].code, errors[0].params);
                        isValid = false;
                    }
                    else if ($scope.company.zipCode && !Number.isInteger(parseInt($scope.company.zipCode))) {
                        $scope.errorField['zipcode'] = "input-error";
                        errorList.push("company.ONLY_NUMBER_ZIPCODE");
                        isValid = false;
                    }
                }

                if ($scope.company.administrativeContact.email && !emailValidatorService.validate($scope.company.administrativeContact.email)) {
                    $scope.errorField['administrativeContactEmail'] = "input-error";
                    errorList.push("company.INCORRECT_EMAIL_ADM");
                    isValid = false;
                }

                if ($scope.company.commercialContact.email && !emailValidatorService.validate($scope.company.commercialContact.email)) {
                    $scope.errorField['commercialContactEmail'] = "input-error";
                    errorList.push("company.INCORRECT_EMAIL_COM");
                    isValid = false;
                }

                if (!$scope.company.commercialContact.negotiationDestination) {
                    $scope.errorField['commercialContactNegotiationDestination'] = "input-error";
                    isValid = false;
                }


                if ($scope.company.vatNumber && $scope.isCountry('ARGENTINA') && $scope.isValidCuit($scope.company.vatNumber)) {
                    $scope.errorField['cuil'] = "input-error";
                    errorList.push("company.INCORRECT_CUIL");
                    isValid = false;
                }

                if ($scope.company.vatNumber && $scope.isCountry('PANAMA')) {

                    if(!$scope.isValidPanamaRUCDV($scope.panama.rucDV)){
                        $scope.errorField['panama_dv_ruc'] = "input-error";
                        errorList.push("company.INCORRECT_PANAMA_RUC_DV");
                        isValid = false;
                    }

                    if(!$scope.isValidPanamaRUC($scope.company.vatNumber)){
                        $scope.errorField['panama_ruc'] = "input-error";
                        errorList.push("company.INCORRECT_PANAMA_RUC");
                        isValid = false;
                    }

                }

                var country = $scope.company.countryOid;
                var vatNumber = $scope.company.vatNumber;
                var invalidVatErrorCode = country == $scope.getCountryOid('BRAZIL') ? "company.INCORRECT_CNPJ" : "warning.invalidNumberFormat";

                var docType = !$scope.company.fiscalInfo?null:((!$scope.company.fiscalInfo.documentType)?null:$scope.company.fiscalInfo.documentType);

                if (vatNumber && country && $scope.vatNumberValidationMap[country]) {
                    if(vatUniqueIdByCountry[country] &&
                        !$scope.vatNumberValidationMap[country][vatUniqueIdByCountry[country]].validation.call($scope.vatNumberValidationMap[country], vatNumber)){
                        $scope.errorField['cuil'] = "input-error";
                        errorList.push(invalidVatErrorCode);
                        isValid = false;
                    }else if(docType && $scope.vatNumberValidationMap[country][docType] &&
                        !$scope.vatNumberValidationMap[country][docType].validation.call($scope.vatNumberValidationMap[country], vatNumber)){
                        $scope.errorField['cuil'] = "input-error";
                        errorList.push(invalidVatErrorCode);
                        isValid = false;
                    } else if (!parseInt(vatNumber) && (country != '20141') && (country != $scope.getCountryOid('BRAZIL'))){
                        $scope.errorField['cuil'] = "input-error";
                        errorList.push("warning.invalidNumberFormat");
                        isValid = false;
                    }
                }

                if ($scope.company.vatNumber && $scope.isCountry('ARGENTINA') && !$scope.isCountry('COLOMBIA') && !$scope.isCountry('PANAMA') &&
                    ($scope.company.vatNumber.length < 4 || $scope.company.vatNumber.length > 20) && isValid) {
                    $scope.errorField['cuil'] = "input-error";
                    errorList.push("company.INCORRECT_ID_TRIBUTARIO");
                    isValid = false;
                }

                if (!isValid && errorList.length > 0) {
                    $scope.notifyFrontErrorDetailByCodes($scope.normalizeBrazilVatErrors(errorList));
                }

                return isValid;
            }

            $scope.isValidCuit = function (vatNumber) {
                var partA = vatNumber.substr(0, 2);
                var partB = vatNumber.substr(3, 8);
                var partC = vatNumber.substr(12, 1);
                if ((!partA || !partB || !partC) || (!Number.isInteger(parseInt(partA)) || !Number.isInteger(parseInt(partB)) || !Number.isInteger(parseInt(partC)))) {
                    return true;
                }
                return false;
            }

            $scope.isValidPanamaRUC = function (vatNumber) {
                var valid = $scope.regexPanamaRuc.test(vatNumber);
                return (valid && vatNumber.length <= 30 && vatNumber.length > 0);
            }

            $scope.isValidPanamaRUCDV = function (dvNumber) {
                return $scope.regexPanamaRucDV.test(dvNumber);
            }

            $scope.normalizeBrazilCnpj = function(vatNumber) {
                if (!vatNumber) {
                    return "";
                }
                return vatNumber.toUpperCase().replace(/[^A-Z0-9]/g, '');
            }

            $scope.formatBrazilCnpj = function(vatNumber) {
                var normalized = $scope.normalizeBrazilCnpj(vatNumber).substring(0, 14);

                if (normalized.length <= 8) {
                    return normalized;
                }

                if (normalized.length <= 12) {
                    return normalized.substring(0, 8) + '/' + normalized.substring(8);
                }

                return normalized.substring(0, 8) + '/' + normalized.substring(8, 12) + '-' + normalized.substring(12);
            }

            $scope.brazilCnpjCharValue = function(character) {
                return character.charCodeAt(0) - 48;
            }

            $scope.calculateBrazilCnpjDigit = function(base, weights) {
                var sum = 0;
                for (var i = 0; i < weights.length; i++) {
                    sum += $scope.brazilCnpjCharValue(base.charAt(i)) * weights[i];
                }
                var mod = sum % 11;
                return mod < 2 ? 0 : (11 - mod);
            }

            $scope.hasValidBrazilCnpjDigits = function(normalizedCnpj) {
                var firstDigit = $scope.calculateBrazilCnpjDigit(normalizedCnpj.substring(0, 12), [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);
                var secondDigit = $scope.calculateBrazilCnpjDigit(normalizedCnpj.substring(0, 12) + firstDigit, [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);

                return normalizedCnpj.substring(12) === ("" + firstDigit + secondDigit);
            }

            $scope.isUnchangedBrazilVatNumber = function(vatNumber) {
                if (!$scope.isCountry('BRAZIL') || !$scope.company || !$scope.company.oid) {
                    return false;
                }

                return $scope.normalizeBrazilCnpj(vatNumber) === $scope.normalizeBrazilCnpj($scope.originalBrazilVatNumber);
            }

            $scope.isValidBrazilCnpj = function(vatNumber) {
                var normalized = $scope.normalizeBrazilCnpj(vatNumber);

                if (!$scope.regexBrazilCnpj.test(normalized)) {
                    return false;
                }

                return $scope.hasValidBrazilCnpjDigits(normalized);
            }

            $scope.isValidRNT = function (rntNumber) {
                if ($scope.isCountry('COLOMBIA')) {
                    return $scope.regexColombiaRNT.test(rntNumber);
                }
               return true;
            }

            $scope.isValidRNTLength = function (rntNumber) {
               return rntNumber.length <= 20;
            }

            var vatUniqueIdByCountry = {
                '20141': 'RFC',
                '20158': 'RUC',
                '20028': 'CNPJ'
            }

        $scope.vatNumberValidationMap = {
            '20141':{
                'RFC': {validation: (function (value) { return (value.length >= 12) && (value.length <= 13);}), label: $translate.instant('company.validation.minmax.INLINE', {min:12, max:13})}
            },
            '20158':{
                'RUC': {validation:(function (value) { return value.length == 11;}), label: $translate.instant('company.validation.INLINE', {length:11})}
            },
            '20042':{
                'RUT': {validation:(function (value) { return value.length == 9;}), label: $translate.instant('company.validation.INLINE', {length:9})}
            },
            '20057':{
                'RUC': {validation:(function (value) { return value.length == 13;}), label: $translate.instant('company.validation.INLINE', {length:13})}
            },
            '20028':{
                'CNPJ': {
                    validation:(function (value) {
                        return $scope.isValidBrazilCnpj(value) || $scope.isUnchangedBrazilVatNumber(value);
                    }),
                    label: $translate.instant('company.validation.INLINE', {length:14})
                }
            }
        }

            $scope.copyAdministrativeContact = function () {
                var id = null;
                if ($scope.tabId == 2) {
                    id = $scope.company.commercialContact.oid;
                    angular.copy($scope.company.administrativeContact, $scope.company.commercialContact);
                    $scope.company.commercialContact.oid = id;
                }
                if ($scope.tabId == 3) {
                    if ($scope.company.emergencyContact) {
                        id = $scope.company.operatingContact.oid;
                        $scope.company.operatingContact = {}
                    } else {
                        $scope.company.operatingContact = {}
                    }
                    angular.copy($scope.company.administrativeContact, $scope.company.operatingContact);
                    $scope.company.operatingContact.oid = id;
                }
                if ($scope.tabId == 4) {
                    if ($scope.company.emergencyContact) {
                        id = $scope.company.emergencyContact.oid;
                        $scope.company.emergencyContact = {}
                    } else {
                        $scope.company.emergencyContact = {}
                    }
                    angular.copy($scope.company.administrativeContact, $scope.company.emergencyContact);
                    $scope.company.emergencyContact.oid = id;
                }
            }

            $scope.showAdministrativeData = function () {
                if ($scope.tabId == 0) return;
                $scope.title = "Administrative Data";
                $scope.contactInfo = null;
                $scope.tabId = 0;
            }

            $scope.showAdministrativeContact = function () {
                $scope.title = "Administrative Contact";
                $scope.tabId = 1;
            }

            $scope.showCommercialContact = function () {
                $scope.title = "Commercial Contact";
                $scope.tabId = 2;
            }

            $scope.showOperatingContact = function () {
                $scope.title = "Operating Contact";
                $scope.tabId = 3;
            }

            $scope.showEmergencyContact = function () {
                $scope.title = "Emergency Contact";
                $scope.tabId = 4;
            }

            $scope.mapVatNumberLabel = function () {
                $scope.vatNumberMap = {
                    '20028': 'CNPJ',
                    '20027': 'NIT',
                    '20045': {'NIT':'NIT', 'CC':'Cédula de ciudadania'},
                    '20188': 'NIT',
                    '20081': 'NIT',
                    '20010': 'CUIT/CUIL',
                    '20042': {'RUT':'RUT', 'RUN':'RUN'},
                    '20209': 'RUT',
                    '20046': 'CJ',
                    '20057': {'RUC':'RUC','CI':'Cédula de identidad'},
                    '20149': 'RUC',
                    '20157': {'RUC':'RUC'},
                    '20168': 'RUC',
                    '20158': 'RUC',
                    '20061': 'NIF',
                    '20208': 'FEI/EIN',
                    '20165': 'FEI/EIN',
                    '20086': 'RTN',
                    '20141': 'RFC',
                    '20055': 'RNC',
                    '20187': 'RNC',
                    '20213': 'RIF'
                }
            }

             $scope.replaceAtIndex = function(inputString, index, toReplace, replacement) {
                return inputString.substr(0, index) + inputString.substr(index-1 + replacement.length).replace(toReplace,replacement);
            }

            $scope.shouldShow = function (component) {
                switch (component) {
                    case 'BUSINESS_NAME':
                        return (!$scope.isCountry('COLOMBIA') && !$scope.isCountry('MEXICO')) ||  ($scope.company.fiscalInfo && ($scope.company.fiscalInfo.type ==='LEGAL' || $scope.company.fiscalInfo.type ==='MORAL'));
                    case 'FIRST_NAME':
                        return $scope.company.fiscalInfo && ($scope.company.fiscalInfo.type === 'NATURAL' || $scope.company.fiscalInfo.type === 'FISICA' );
                    case 'RECEIPT_METHOD':
                        return $scope.isCountry('COLOMBIA') || $scope.isCountry('MEXICO');
                    case 'STATE':
                        return $scope.isCountry('BRAZIL');
                    case 'RETENTION_AGENT':
                        return $scope.isCountry('PERU');
                    case 'DOCUMENT_T':
                        return $scope.isCountry('COLOMBIA') || $scope.isCountry('CHILE') || $scope.isCountry('ECUADOR');
                    case 'CUIL':
                        return !$scope.isCountry('PANAMA');
                    case 'FISCO':
                        return $scope.isCountry('ARGENTINA') || $scope.isCountry('COLOMBIA');
                    case 'PANAMA_RUC':
                        return $scope.isCountry('PANAMA');
                    case 'ZIPCODE':
                        return !$scope.isCountry('BRAZIL');
                    case 'ZIPCODE_BRASIL':
                        return $scope.isCountry('BRAZIL');
                    case 'PERSON_TYPES':
                        return $scope.isCountry('MEXICO') || $scope.isCountry('COLOMBIA');
                    case 'ECONOMICAL_ACTIVITIES':
                        return $scope.isCountry('MEXICO');
                    case 'NATIONAL_TOURISM_REGISTRY' :
                        return $scope.isCountry('COLOMBIA');
                    default:

                }
            }

            $scope.componentRequired = function (component) {
                switch (component) {
                    case 'BUSINESS_NAME':
                        return (!$scope.isCountry('COLOMBIA') && !$scope.isCountry('MEXICO')) ||  ($scope.company.fiscalInfo && ($scope.company.fiscalInfo.type ==='LEGAL' || $scope.company.fiscalInfo.type ==='MORAL'));
                    case 'SURNAME':
                        return $scope.company.fiscalInfo && $scope.company.fiscalInfo.type === 'NATURAL' && !$scope.isCountry('PANAMA');
                    case 'SATATE':
                        return $scope.isCountry('BRAZIL');
                    case 'RETENTION_AGENT':
                        return $scope.isCountry('PERU');
                    case 'DOCUMENT_T':
                        return $scope.isCountry('COLOMBIA') || $scope.isCountry('CHILE') || $scope.isCountry('ECUADOR');
                    case 'FISCO':
                        return $scope.isCountry('ARGENTINA') || $scope.isCountry('COLOMBIA');
                    case 'PANAMA_RUC':
                        return $scope.isCountry('PANAMA');
                    case 'FIRST_NAME':
                        return $scope.company.fiscalInfo && $scope.company.fiscalInfo.type === 'NATURAL' && !$scope.isCountry('PANAMA');
                    case 'CUIL':
                        return !$scope.isCountry('PANAMA');
                    case 'PERSON_TYPES':
                        return $scope.isCountry('MEXICO');
                    case 'ECONOMICAL_ACTIVITIES':
                        return $scope.isCountry('MEXICO');
                    case 'NATIONAL_TOURISM_REGISTRY':
                        return $scope.isCountry('COLOMBIA');
                    default:

                }
            }


            $scope.getValidationDescription=function (company, doc) {
                var vatLabel = getVatNumberLabel (company, !doc?null:doc);
                if(vatLabel && $scope.vatNumberValidationMap[company] && $scope.vatNumberValidationMap[company][vatLabel]){
                    return $scope.vatNumberValidationMap[company][vatLabel].label;
                }
            }

            function getVatNumberLabel (countryOid, docType){
                var label = $scope.vatNumberMap[countryOid];
                if(label && docType){
                    return label[docType];
                }else if(typeof label === 'string'){
                    return label;
                }
                return null;
            }

            $scope.getVatNumberLabel = function (countryOid) {
                var vatLabel = getVatNumberLabel (countryOid, !$scope.company.fiscalInfo?null:$scope.company.fiscalInfo.documentType);
                if(!vatLabel){
                    return $translate.instant('company.cuit.ELSE');
                }
                return vatLabel;
            }

        $scope.getLogo = function () {
            if ($scope.company.logoOid) {
                resourceService.get({oid: $scope.company.logoOid}, function (response) {
                    $scope.companyLogo = response.url + "/140x70";
                });
            }
        }

            $scope.initialize();
        }]);





//////////////////
// WEBPACK FOOTER
// ./public/app/controllers/company_controller.js
// module id = 899
// module chunks = 3